var Handlebars = require("../../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span id=\"combo-pdf-doc-nav-btn\" title=\"Combine pages of all renderable documents into single PDF\">\n    <i class=\"icm-file-pdf3\"></i>\n</span>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/nav/navBar/comboPdf/pdfDropDownButton/template.hbs
 ** module id = 703
 ** module chunks = 0
 **/